import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { EventReportResponse } from '../services/api/event-analytics.api';
import { reportsExecutionApi } from '../services/api/reports.api';
import type { ReportExecution } from '../services/api/reports.api';

interface ReportsState {
  /** In-session event report generations (prepended on each successful POST) */
  eventGenerations: EventReportResponse[];
  /** Execution history from GET /reports/executions */
  executionHistory: ReportExecution[];
  loadingHistory: boolean;
  historyError: string | null;
}

const initialState: ReportsState = {
  eventGenerations: [],
  executionHistory: [],
  loadingHistory: false,
  historyError: null,
};

export const fetchReportExecutions = createAsyncThunk(
  'reports/fetchExecutions',
  async (params?: { limit?: number; dateFrom?: string }) => {
    const res = await reportsExecutionApi.getExecutions({
      page: 1,
      limit: params?.limit ?? 20,
      ...(params?.dateFrom !== undefined ? { dateFrom: params.dateFrom } : {}),
    });
    return res.data;
  },
);

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    addEventGeneration(state, action: PayloadAction<EventReportResponse>) {
      state.eventGenerations.unshift(action.payload);
      if (state.eventGenerations.length > 50) {
        state.eventGenerations = state.eventGenerations.slice(0, 50);
      }
    },
    clearEventGenerations(state) {
      state.eventGenerations = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportExecutions.pending, (state) => {
        state.loadingHistory = true;
        state.historyError = null;
      })
      .addCase(fetchReportExecutions.fulfilled, (state, action) => {
        state.loadingHistory = false;
        state.executionHistory = action.payload;
      })
      .addCase(fetchReportExecutions.rejected, (state, action) => {
        state.loadingHistory = false;
        state.historyError = action.error.message ?? 'Ошибка загрузки истории';
      });
  },
});

export const { addEventGeneration, clearEventGenerations } = reportsSlice.actions;
export default reportsSlice.reducer;
